type AdminUnreadDotProps = {
  label: string;
};

export function AdminUnreadDot({ label }: AdminUnreadDotProps) {
  return (
    <span
      className='h-2 w-2 shrink-0 rounded-full bg-red-500'
      aria-label={label}
    />
  );
}
